// extracted by mini-css-extract-plugin
export default {"btnn":"styles_btnn__ROv0i","btnnNo":"styles_btnnNo__SRqrs","btnnYes":"styles_btnnYes__1lr1w"};